import dayjs from 'dayjs';
import { Component, Vue, Ref, Prop } from "vue-property-decorator";

@Component({
  components: {

  }
})
export default class Alarm extends Vue {
  get columns() {
    return [
      {
        title: this.$t('page_material_ware_move_orderCode'),
        dataIndex: 'orderCode',
        key: 'orderCode',
        width: 200,
        ellipsis: true,
        customRender: (sort, _record, index) => {
          return (
            <span>
              { sort }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_torderName'),
        dataIndex: 'orderName',
        key: 'orderName',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { value }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_shiftDept'),
        dataIndex: 'shiftDept',
        key: 'shiftDept',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findDept(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_shiftTime'),
        dataIndex: 'shiftTime',
        key: 'shiftTime',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
             { value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''}
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_shiftUser'),
        dataIndex: 'shiftUser',
        key: 'shiftUser',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findUser(value) }
            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_stockout'),
        dataIndex: 'stockOutTypeId',
        key: 'stockOutTypeId',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findOutType(value) }

            </span>
          )
        },
      },
      {
        title: this.$t('page_material_ware_move_stockin'),
        dataIndex: 'stockInTypeId',
        key: 'stockInTypeId',
        width:200,
        ellipsis: true,
        customRender: (value, _record, index) => {
          return (
            <span>
              { this.findstockIn(value) }
            </span>
          )
        },
      }
    ]
  };
  @Prop({ default: () => [] }) readonly data: Array<string>;
  @Prop({ default: () => [] }) readonly employeesList: Array<any>;
  @Prop({ default: () => [] }) readonly listAllTree: Array<any>;
  @Prop({ default: () => [] }) readonly outTypeList: Array<any>;
  @Prop({ default: () => [] }) readonly stockInList: Array<any>;
  @Prop({ default: ""}) readonly current: String;
  @Prop({ default: ""}) readonly pageSize: String;
  @Prop({ default: ""}) readonly total: String;
  @Prop({ default: false }) readonly loading: Boolean;
  @Prop({ default: 300 }) readonly height: Number;
  @Prop({ default: ""}) readonly selectId: String;
  @Prop({ default: () => [] }) readonly selectedRowKeys: Array<any>;

  onSelectChange(selectedRowKeys) {
    this.$emit('onSelectChange',selectedRowKeys)
  }

  findUser(value){
    const user = this.employeesList.find(res => res.id === value)
    return user ? user.name : ""
  }

  findDept(value){
    const dept = this.listAllTree.find(res => res.key === value)
    return dept ? dept.title : ""
  }
  
  findOutType(value){
    console.log(this.outTypeList,value)
    const dept = this.outTypeList.find(res => res.id === value)
    return dept ? dept.name : ""
  }
  
  findstockIn(value){
    const dept = this.stockInList.find(res => res.id === value)
    return dept ? dept.name : ""
  }

  handleTableChange(current: number, pageSize: number) {
    const pager = {
      pageSize: pageSize,
      current: current
    }
    this.$emit('handleTableChange', pager)
  }
  
  showTotal(total){
    return (this.$t('Total…items') as string).replace('{0}', total)
  }

  clickRow(record){
    this.$emit('clickRow', record.id)
  }

  render() {
    return (
      <div>
        <ml-table
          pagination={false}
          columns={this.columns}
          dataSource={this.data}
          bordered
          rowKey="id"
          selectRowKey={this.selectId}
          loading={this.loading}
          scroll={{ y: this.height, x: 1400 }}
          row-selection={{ selectedRowKeys: this.selectedRowKeys, onChange: this.onSelectChange }}
          customRow={(record) => {
            return {
              on: { // 事件
                click: () => this.clickRow(record),       // 点击行
              },
            };
          }}
        >
        </ml-table>
        <a-pagination
          style="position:absolute;bottom: 4px;right: 20px"
          show-total={total => `${ this.showTotal(total) }`}
          current={ this.current }
          pageSize={ this.pageSize }
          total={ this.total }
          on-change={ this.handleTableChange }
          on-showSizeChange={ this.handleTableChange }
        />
      </div>
    )
  }
}